import { Image } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { galleryRow } from '../layouts/rows'
import { lazyPage } from '@/lib/lazyPage'

const GalleryPage = lazyPage(() => import('@/pages/Gallery'), 'GalleryPage')

export const galleryModule: ModuleDefinition = {
  key: 'gallery',
  icon: Image,
  iconName: 'image',
  namespaces: ['gallery'],
  ready: true,
  /* F-198: the default is what the page always drew. */
  layouts: { fallback: 'grid', renders: ['grid', 'feed'], toRow: galleryRow },
  ListPage: GalleryPage
}
